import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { modalEventListener } from "../../../../utils/ModalEventListener";

const AssignCheckerModal = ({
  id,
  user_id,
  assignCheckerFunc,
  closeAssignCheckerModal,
}) => {
  const ref = useRef();
  useEffect(() => {
    return modalEventListener(ref, closeAssignCheckerModal);
  }, [closeAssignCheckerModal]);
  return ReactDOM.createPortal(
    <div className="modal-wrapper" id="modal-wrapper">
      <div className="assign-checker-modal-content" ref={ref}>
        <div className="modal-header"></div>
        <div className="modal-body clearfix">
          <label id="confirm_submit_lable">
            Are you sure you want to process this case ?
          </label>
          <input type="hidden" id={`checker_id${id}`} value={user_id} />
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn rc-btn_rset pad-L20 pad-R20"
            onClick={closeAssignCheckerModal}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn rc-btn_primary pad-L20 pad-R20 submit-btn-checker"
            onClick={() => {
              assignCheckerFunc("submit", 1, 6, "dtsStage2");
            }}
          >
            Submit
          </button>
        </div>
      </div>
    </div>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default AssignCheckerModal;
